import { KNOWN_QUERY_PARAMS } from 'constants/queryParams';

/**
 * Removes specified query parameters from the current URL without reloading the page.
 * @param paramsToRemove Array of query parameter keys to remove.
 */
export const removeQueryParamsFromUrl = (paramsToRemove: string[]): void => {
  const url = new URL(globalThis.location.href);
  let hasChanged = false;

  paramsToRemove.forEach((param) => {
    if (KNOWN_QUERY_PARAMS.includes(param) && url.searchParams.has(param)) {
      url.searchParams.delete(param);
      hasChanged = true;
    }
  });

  if (hasChanged) {
    globalThis.history.replaceState({}, '', url.toString());
  }
};
